import { ISanitizedCompany } from 'types/company';
import { StoryRenderModes } from 'types/story';

export const storyFactory = ({
  company,
  userId,
  collectionId,
}: {
  company: ISanitizedCompany;
  userId: string;
  collectionId: string;
}) => {
  return {
    title: 'Story Title',
    meta: {
      collectionId: collectionId,
      companyId: company.id,
      userId,
      description: 'Short & attention-grabbing subtitle',
      createdAt: new Date(),
      publishedAt: null,
      showInFeed: true,
      public: false,
      updatedAt: null,
      duration: 3,
      topicsList: [],
      topicsPermutations: [],
      renderMode: StoryRenderModes.FLEXIBLE,
      team: [],
    },
  };
};
